import ExcelJS from 'exceljs';

export default class FormMonederoExcel {
  static generateWorkbook(data) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Monedero');

    // Definir los encabezados de la tabla
    const headers = [
      'Fecha',
      'Descripción',
      'Cantidad',
      'Cliente',
      'Saldo Anterior',
      'Saldo Posterior',
      'Operación',
      'Origen'
    ];

    // Calcular la última letra de columna (suponiendo menos de 26 columnas)
    const lastColLetter = String.fromCharCode(64 + headers.length);

    // Agregar una fila con el texto "Cliente" (mergeando las celdas)
    worksheet.mergeCells(`A1:${lastColLetter}1`);
    const clientHeaderCell = worksheet.getCell('A1');
    clientHeaderCell.value = 'Cliente';
    clientHeaderCell.font = { bold: true, size: 16 };
    clientHeaderCell.alignment = { horizontal: 'center', vertical: 'middle' };
    clientHeaderCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD3D3D3' } // fondo gris claro
    };

    // Agregar otra fila con el nombre del cliente (usando el campo "Cliente" del primer objeto)
    worksheet.mergeCells(`A2:${lastColLetter}2`);
    const clientNameCell = worksheet.getCell('A2');
    const clientName = data[0] && data[0].Cliente ? data[0].Cliente : '';
    clientNameCell.value = clientName;
    clientNameCell.font = { italic: true, size: 14 };
    clientNameCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // Dejar una fila en blanco para separar
    worksheet.addRow([]);

    // Agregar la fila de encabezados de la tabla
    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: 'center' };

    // Aplicar formato a las columnas
    worksheet.columns = [
      { key: 'Fecha', width: 15 },
      { key: 'Descripción', width: 30 },
      { key: 'Cantidad', width: 15, numFmt: '#,##0.00' }, // Formato numérico con 2 decimales
      { key: 'Cliente', width: 20 },
      { key: 'Saldo Anterior', width: 20, numFmt: '#,##0.00' }, // Formato numérico con 2 decimales
      { key: 'Saldo Posterior', width: 20, numFmt: '#,##0.00' }, // Formato numérico con 2 decimales
      { key: 'Operación', width: 15 },
      { key: 'Origen', width: 20 }
    ];

    // Agregar las filas de datos con formato adecuado
    data.forEach(item => {
      const origen = item._m ? item._m.og : '';

      const rowData = {
        Fecha: item.Fecha,
        Descripción: item.Descripcion,
        Cantidad: item.Cantidad || 0, // Asegura que sea numérico
        Cliente: item.Cliente,
        'Saldo Anterior': item.SaldoAnterior || 0, // Asegura que sea numérico
        'Saldo Posterior': item.SaldoPosterior || 0, // Asegura que sea numérico
        Operación: item._Op,
        Origen: origen
      };

      const row = worksheet.addRow(rowData);

      // Aplicar formato numérico a las celdas correspondientes
      row.getCell(3).numFmt = '#,##0.00'; // Cantidad
      row.getCell(5).numFmt = '#,##0.00'; // Saldo Anterior
      row.getCell(6).numFmt = '#,##0.00'; // Saldo Posterior
    });

    // Autoajustar el ancho de las columnas para que se vea el contenido completo
    worksheet.columns.forEach(column => {
      let maxLength = column.width || 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellText = cell.value ? cell.value.toString() : '';
        if (cellText.length > maxLength) {
          maxLength = cellText.length;
        }
      });
      column.width = maxLength + 2; // Se agrega un poco de padding
    });

    return workbook;
  }

  static async generateExcelBuffer(data) {
    const workbook = FormMonederoExcel.generateWorkbook(data);
    return await workbook.xlsx.writeBuffer();
  }
}
